export default {
    app: {
        name: 'ActivityWatch',
    },
    nav: {
        activity: 'Aktivität',
        loading: 'Laden…',
        noActivityReports: 'Keine Aktivitätsberichte verfügbar. Stellen Sie sicher, dass AFK- und Fenster-Watcher laufen.',
        timeline: 'Zeitleiste',
        stopwatch: 'Stoppuhr',
        tools: 'Werkzeuge',
        search: 'Suche',
        workReport: 'Arbeitsbericht',
        trends: 'Trends',
        report: 'Bericht',
        alerts: 'Benachrichtigungen',
        timespiral: 'Timespiral',
        query: 'Abfrage',
        graph: 'Graph',
        rawData: 'Rohdaten',
        settings: 'Einstellungen',
    },
    footer: {
        madeWith: 'Gemacht mit',
        byDevs: 'von den ActivityWatch-Entwicklern',
        host: 'Host:',
        version: 'Version:',
        reportBug: 'Fehler melden',
        askHelp: 'Hilfe anfordern',
        voteFeatures: 'Für Funktionen abstimmen',
        twitter: 'Twitter',
        github: 'GitHub',
        reddit: 'Reddit',
        donate: 'Spenden',
    },
    common: {
        loading: 'Laden…',
        save: 'Speichern',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        import: 'Importieren',
        export: 'Exportieren',
        open: 'Öffnen',
        more: 'Mehr',
        delete: 'Löschen',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        home: 'Startseite',
        language: 'Sprache',
        languageUk: 'Українська',
        languageEn: 'English',
        languageDe: 'Deutsch',
        languageRu: 'Русский',
        languageZhCN: '简体中文',
        rangeTo: 'bis',
    },
    notFound: {
        title: 'Hoppla, diese Seite wurde nicht gefunden!',
        hint: 'Versuchen Sie, dorthin zurückzukehren, woher Sie kamen.',
    },
    settings: {
        title: 'Einstellungen',
        unsavedCategoriesLeave: 'Ihre Kategorien haben ungespeicherte Änderungen. Wirklich verlassen?',
        daystart: {
            startOfDay: 'Tagesbeginn',
            startOfDayHelp: 'Die Uhrzeit, zu der ein neuer Tag „beginnt“ — man schläft nicht immer vor Mitternacht. Standard: 04:00.',
            startOfWeek: 'Wochenbeginn',
            startOfWeekHelp: 'Der Wochentag, an dem eine neue Woche beginnt.',
            saturday: 'Samstag',
            sunday: 'Sonntag',
            monday: 'Montag',
        },
        timelineDuration: {
            title: 'Standarddauer',
            help: 'Standarddauer für „Zuletzt anzeigen“ in der Zeitleiste.',
        },
        landingPage: {
            title: 'Einstiegsseite',
            home: 'Startseite',
            activity: 'Aktivität ({hostname})',
            timeline: 'Zeitleiste',
            help: 'Die Seite beim Öffnen von ActivityWatch oder Klick auf das Logo.',
        },
        theme: {
            title: 'Design',
            auto: 'Automatisch (System)',
            light: 'Hell',
            dark: 'Dunkel',
            help: 'Farbschema der Anwendung (Kategoriefarben für den Dunkelmodus ggf. manuell anpassen).',
        },
        groups: {
            general: 'Allgemein',
            generalHelp: 'Standardwerte für Zeiträume, Timeline und Startseite.',
            appearance: 'Darstellung',
            appearanceHelp: 'Design und Farben der Visualisierungen.',
            categorization: 'Kategorisierung',
            categorizationHelp: 'Regeln zur Einstufung von Ereignissen in Kategorien sowie AFK-/Aktivitäts-Overrides.',
            privacy: 'Datenschutz',
            privacyHelp: 'Filter, die sensible Ereignisdaten vor dem Speichern verwerfen oder ausblenden.',
            developer: 'Entwickler',
        },
        language: {
            title: 'Sprache',
            help: 'Sprache der Web-Oberfläche.',
        },
        releaseNotification: {
            title: 'Auf neue Versionen prüfen',
            help: 'Wenn aktiviert, prüft die Weboberfläche einmal täglich auf eine neue ActivityWatch-Version und zeigt einen Hinweis an.',
        },
        color: {
            title: 'Ersatzfarben verwenden',
            help: 'Alte Farbgebung für einige Visualisierungen ohne Kategorie oder Kategoriefarbe.',
        },
        activePattern: {
            title: 'Immer als aktiv zählen (Regex)',
            help1: 'Apps oder Titel, die diesem Regex entsprechen, werden nie als AFK gezählt.',
            help2: 'Nützlich für Meetings oder Controller-Spiele ohne Tastatur/Maus-Eingabe. Leerer String deaktiviert die Regel.',
            example: 'Beispielausdruck:',
            invalid: 'Ungültiges Muster',
            tooBroad: 'Muster zu allgemein',
        },
        categorization: {
            title: 'Kategorisierung',
            restoreDefaults: 'Standard wiederherstellen',
            rulesHelp: 'Regeln zur Kategorisierung von Ereignissen. Ein Ereignis hat nur eine Kategorie. Bei mehreren Treffern wird die tiefste gewählt.',
            builderIntro: 'Sie können den',
            categoryBuilder: 'Kategorie-Builder',
            builderOutro: 'nutzen, um schnell Kategorien aus unkategorisierter Aktivität zu erstellen.',
            forumIntro: 'Fertige Regelsätze finden Sie im',
            forum: 'Forum',
            docsIntro: 'Hilfe zum Schreiben von Regeln finden Sie in der',
            documentation: 'Dokumentation',
            categorySet: 'Kategoriesatz:',
            newSet: 'Neuer Satz',
            deleteSet: 'Satz löschen',
            setsAvailable: '{count} Sätze verfügbar — wechseln Sie zwischen Regelprofilen.',
            unsavedChanges: 'Ungespeicherte Änderungen!',
            discard: 'Verwerfen',
            addCategory: 'Kategorie hinzufügen',
            categories: 'Kategorien',
            builderTitle: 'Kategorie-Builder',
            builderSubtitle: 'Regeln aus unkategorisierter Aktivität erzeugen',
            openBuilder: 'Builder öffnen',
            hideBuilder: 'Builder ausblenden',
        },
        developer: {
            title: 'Entwicklereinstellungen',
            note: 'Hinweis:',
            noteBody: 'Diese Einstellungen sind für Entwickler gedacht und können unerwartet etwas kaputt machen.',
            forceDevmode: 'Devmode erzwingen',
            forceDevmodeHelp: 'Devmode aktiviert noch unfertige Funktionen.',
            showYearly: 'Jahreszeitraum anzeigen',
            showYearlyHelp: 'Eine Abfrage über ein ganzes Jahr ist sehr schwer und führt oft zu Timeouts. Mit aw-server-rust kann es schneller sein.',
            multidevice: 'Multi-Device-Abfrage',
            multideviceHelp: 'Frühes Experiment: Ereignisse von mehreren Hosts in der Aktivitätsansicht. Browser-Buckets und „Audio = aktiv“ werden noch nicht unterstützt.',
            requestTimeout: 'Anfrage-Timeout',
            requestTimeoutHelp: 'Maximale Wartezeit auf Serverantwort. Für große Abfragen erhöhen. Web-UI neu laden, damit es wirkt.',
            commitHash: 'Web-UI-Commit-Hash:',
        },
    },
    home: {
        note: 'Hinweis:',
        androidNote: 'ActivityWatch auf Android befindet sich in einem sehr frühen Entwicklungsstadium. Es gibt Fehler, aber wir arbeiten an Parität mit der Desktop-Version (probieren Sie sie!).',
        greeting: 'Willkommen bei ActivityWatch',
        intro1: 'Wir sind schon weit gekommen{android}, brauchen aber weiterhin Nutzer (wie Sie!), um ActivityWatch zu einem erfolgreichen Projekt zu machen. Wir freuen uns über Ihre Ideen zur Verbesserung.',
        introAndroid: ' (besonders auf Android!)',
        intro3: 'Als Entwickler können Sie mit einem Watcher, einer Visualisierung o. Ä. beitragen und im Forum teilen!',
        thanks: 'Danke, dass Sie ActivityWatch nutzen!',
        surveyFill: 'Nehmen Sie an unserer Nutzerumfrage teil',
        surveySuffix: 'um mitzubestimmen, was als Nächstes kommt.',
        surveyOr: 'oder',
        voteForum: 'stimmen Sie im Forum für Funktionen ab',
        spreadTitle: 'Weiterempfehlen',
        spread1: 'Nichts motiviert mehr als Nutzer, die ActivityWatch ausprobieren. Teilen Sie es — wir machen es noch besser!',
        spreadReview: 'Geben Sie uns eine Bewertung auf',
        spreadVote: 'Stimmen Sie für uns ab auf',
        spreadFollow: 'Folgen Sie uns und teilen Sie auf',
        spreadStar: 'Geben Sie uns einen Stern auf',
        supportTitle: 'Unterstützen Sie uns!',
        subscribeIntro: 'The best way to keep ActivityWatch maintained is a subscription — from $5/month, every feature stays free, cancel anytime.',
        subscribeCta: 'Support ActivityWatch →',
        support1: 'Gefällt Ihnen ActivityWatch? Helfen Sie uns, Ihnen zu helfen — spenden Sie über:',
        support2: 'Mehr Infos auf der',
        donationPage: 'Spendenseite der Website',
        otherDonationMethods: 'Weitere Methoden (inkl. Kryptowährung)',
        resourcesTitle: 'Ressourcen',
        website: 'Website',
        documentation: 'Dokumentation',
        forum: 'Forum',
        discord: 'Discord',
        reddit: 'Reddit',
        apiBrowser: 'API-Browser',
        workingOnTitle: 'Woran wir arbeiten',
        workingOnPrefix: 'Bleiben Sie auf dem Laufenden mit den',
        devUpdates: 'Entwicklungsupdates',
        workingOnMiddle: 'und folgen Sie dem Projekt auf',
        workingOnSuffix: 'für Release-Hinweise.',
        landingHint: 'Welche Seite beim Öffnen von ActivityWatch erscheint (statt dieser), können Sie in den',
        supporterNudge: {
            message: "You've been getting a lot out of ActivityWatch — would you consider supporting its development?",
            support: 'Support ActivityWatch →',
            notNow: 'Not now',
        },
    },
    buckets: {
        title: 'Buckets',
        moreWatchers: 'Möchten Sie mehr Daten sammeln? Sehen Sie in der',
        docsLink: 'Dokumentation',
        thisDevice: 'dieses Gerät',
        lastUpdatedInline: 'Zuletzt aktualisiert',
        noEventsYet: 'Noch keine Ereignisse aufgezeichnet',
        noEvents: 'keine Ereignisse',
        moreActionsFor: 'Weitere Aktionen für {hostname}',
        deleteAllTitle: 'Alle {count} Buckets für {hostname} löschen',
        deleteAllForHost: 'Alle Buckets dieses Hosts löschen',
        openBucket: 'Bucket öffnen',
        deleteBucketTitle: 'Bucket löschen?',
        deleteHostTitle: 'Buckets löschen?',
        deleteHostTitleNamed: 'Alle Buckets für {hostname} löschen?',
        deleteHostConfirmPrefix: 'Möchten Sie wirklich',
        deleteHostConfirmCount: 'alle {count} Buckets',
        deleteHostConfirmSuffix: 'für Host "{hostname}" löschen?',
        bucketsToDelete: 'Buckets, die gelöscht werden:',
        deleting: 'Wird gelöscht…',
        importing: 'Importiere…',
        importHelpNew: 'JSON-Datei aus einem oder mehreren Buckets. Der Import schlägt fehl, wenn bereits ein Bucket mit derselben ID existiert.',
        exportHelp: 'Alle Buckets auf diesem Server als eine JSON-Datei herunterladen. Für Backups.',
        currentDevice: '(aktuelles Gerät)',
        lastUpdated: 'Zuletzt aktualisiert:',
        firstSeen: 'Zuerst gesehen:',
        bucketId: 'Bucket-ID',
        updated: 'Aktualisiert',
        exportBucketJson: 'Bucket als JSON exportieren',
        exportEventsCsv: 'Ereignisse als CSV exportieren',
        deleteBucket: 'Bucket löschen',
        deleteModalTitle: 'Achtung!',
        deleteConfirm: 'Bucket "{id}" wirklich löschen?',
        deletePermanent: 'Das ist endgültig und kann nicht rückgängig gemacht werden!',
        importExportTitle: 'Buckets importieren und exportieren',
        importBuckets: 'Buckets importieren',
        importPlaceholder: 'Datei wählen oder hier ablegen…',
        importDrop: 'Datei hier ablegen…',
        importHelp: 'Gültig ist JSON: Export eines Buckets oder mehrerer. Bei gleichen Namen schlägt der Import fehl.',
        exportBuckets: 'Buckets exportieren',
        exportAllJson: 'Alle Buckets als JSON exportieren',
        tools: 'Werkzeuge',
    },
    activity: {
        title: 'Aktivität',
        for: 'für',
        host: 'Host:',
        timeActive: 'Aktive Zeit:',
        queryRange: 'Abfragezeitraum:',
        filters: 'Filter',
        filtersTitle: 'Filter',
        refresh: 'Aktualisieren',
        excludeAfk: 'AFK-Zeit ausschließen',
        audibleActive: 'Hörbaren Browser-Tab als aktiv zählen',
        includeStopwatch: 'Manuell erfasste Ereignisse (Stoppuhr) einbeziehen',
        newView: 'Neue Ansicht',
        loadDemo: 'Demo-Daten laden',
        periodDay: 'Tag',
        periodWeek: 'Woche',
        periodMonth: 'Monat',
        periodYear: 'Jahr',
        periodLast7d: '7 Tage',
        periodLast30d: '30 Tage',
        periodLast7dTitle: 'letzte 7 Tage',
        periodLast30dTitle: 'letzte 30 Tage',
        filterAfkTooltip: 'Zeit ausblenden, in der der AFK-Watcher keine Eingabe erkannt hat.',
        filterAudibleTooltip: 'Aktives Fenster mit hörbarem Browser-Tab als aktiv zählen. Erfordert Browser-Watcher.',
        showCategory: 'Kategorie anzeigen',
        newViewTitle: 'Neue Ansicht',
        viewId: 'ID',
        viewName: 'Name',
        stopwatchWipNote: 'Hinweis: WIP. Stoppuhr-Ereignisse überdecken andere bei Überlappung. Nur im Devmode.',
        invalidForm: 'Ungültige Eingabe: {errors}',
        errIdNotUnique: 'ID ist nicht eindeutig',
        errMissingId: 'ID fehlt',
        errMissingName: 'Name fehlt',
    },
    activityView: {
        addVisualization: 'Visualisierung hinzufügen',
        cancel: 'Abbrechen',
        save: 'Speichern',
        restoreDefaults: 'Standard wiederherstellen',
        remove: 'Entfernen',
        editView: 'Ansicht bearbeiten',
        restoreAlert: 'Alle Ansichten auf Standard zurückgesetzt. Änderungen werden erst nach Speichern übernommen.',
        removeViewTitle: 'Diese Ansicht entfernen?',
        removeViewOk: 'Ansicht entfernen',
        removeViewConfirm: 'Möchten Sie wirklich entfernen',
        removeViewHint: 'Dadurch wird die Konfiguration der Ansicht gelöscht. Sie können',
        removeViewRestoreHint: 'ausführen, um Standardansichten wiederherzustellen.',
        promptWatcher: 'Watcher-Namen eingeben',
        promptTitle: 'Titel der Visualisierung eingeben',
    },
    uncategorized: {
        title: 'Viel unkategorisierte Zeit',
        body: 'Insgesamt {duration} unkategorisiert — das sind {percent}% der Zeit {period}.',
        hint: 'Beheben mit dem',
        categoryBuilder: 'Kategorie-Builder',
        settingsCogTitle: 'Diesen Hinweis in den Einstellungen ausblenden oder anpassen',
        periodToday: 'heute',
        periodThisWeek: 'diese Woche',
        periodThisMonth: 'diesen Monat',
        periodThisYear: 'dieses Jahr',
        periodLast7d: 'die letzten 7 Tage',
        periodLast30d: 'die letzten 30 Tage',
    },
    visualizations: {
        noData: '(keine Daten)',
        unsupportedPeriod: 'Diese Funktion unterstützt den gewählten Zeitraum nicht.',
        missingWatcher: 'Daten eines erforderlichen Watchers fehlen.',
        docLink: 'Dokumentation',
        allCategories: 'Alle',
        topApps: 'Top-Anwendungen',
        topTitles: 'Top-Fenstertitel',
        topDomains: 'Top-Browser-Domains',
        topUrls: 'Top-Browser-URLs',
        topBrowserTitles: 'Top-Browser-Titel',
        topEditorFiles: 'Top-Editor-Dateien',
        topEditorLanguages: 'Top-Editor-Sprachen',
        topEditorProjects: 'Top-Editor-Projekte',
        topCategories: 'Top-Kategorien',
        categoryTree: 'Kategoriebaum',
        categorySunburst: 'Kategorie-Sunburst',
        timelineBarchart: 'Zeitleiste (Balken)',
        sunburstClock: 'Sunburst-Uhr',
        dailyTimeline: 'Tages-Zeitleiste (chronologisch)',
        customVis: 'Eigene Visualisierung',
        score: 'Score',
        topStopwatches: 'Top-Stoppuhr-Ereignisse',
        topBucketData: 'Top-Bucket-Daten',
    },
    timeline: {
        title: 'Zeitleiste',
        eventsShown: 'Angezeigte Ereignisse:',
        swimlanes: 'Schwimmbahnen:',
        filterAfk: 'AFK filtern',
        mergeByApp: 'Nach App zusammenführen',
        noEvents: 'Keine Ereignisse entsprechen den Kriterien. Zeitleiste nicht aktualisiert.',
        scrollHint: 'Scrollen zum Zoomen, Wischen zum Schwenken, Pfeiltasten zur Navigation',
        loading: 'Laden…',
    },
    stopwatch: {
        title: 'Stoppuhr',
        usingBucket: 'Bucket:',
        aboutTitle: 'Über die Stoppuhr',
        aboutBody: 'Manuell erfasste Sitzungen neben der automatischen Erfassung verfolgen. Um Stoppuhr-Summen im Dashboard zu sehen, öffnen Sie eine Aktivitätsansicht, klicken Sie auf Ansicht bearbeiten, dann Visualisierung hinzufügen und wählen Sie Top-Stoppuhr-Ereignisse.',
        placeholder: 'Woran arbeiten Sie?',
        noRunning: 'Keine Stoppuhr läuft. Starten Sie oben eine, um fokussierte Arbeit zu erfassen.',
        start: 'Start',
        running: 'Läuft',
        history: 'Verlauf',
    },
    search: {
        title: 'Suche',
        earlyDev: 'Diese Funktion befindet sich noch in früher Entwicklung.',
        searchBtn: 'Suchen',
        options: 'Optionen',
        notFound: 'Nicht gefunden, was Sie suchten?',
        addWeek: 'Eine Woche zur Suche hinzufügen:',
        addWeekBtn: '+1 Woche',
    },
    query: {
        title: 'Abfrage-Explorer',
        docsHelp: 'Hilfe zum Schreiben von Abfragen finden Sie in der Dokumentation.',
        start: 'Beginn',
        end: 'Ende',
    },
    workReport: {
        title: 'Arbeitszeitbericht',
        loading: 'Laden…',
    },
    report: {
        title: 'Bericht',
        description: 'Bericht über die in einer Geräteaktivitätskategorie verbrachte Zeit.',
        earlyDev: 'Diese Funktion befindet sich noch in früher Entwicklung.',
        generate: 'Erzeugen',
        options: 'Optionen',
        foundEvents: '{count} Ereignisse in {seconds} Sekunden gefunden',
        csv: 'CSV',
    },
    trends: {
        titlePrefix: 'Trends für',
        earlyDev: 'Diese Funktion befindet sich noch in früher Entwicklung.',
        loadDemo: 'Demo-Daten laden',
    },
    timespiral: {
        title: 'Timespiral',
        wip: 'Experimentelle Funktion in Entwicklung.',
        noAfkBucket: 'Auf diesem Host wurde kein AFK-Bucket gefunden. Installieren Sie',
        noAfkBucketSuffix: 'um Timespiral zu nutzen.',
        bucketLabel: 'Bucket:',
        eventsLabel: 'Ereignisse:',
    },
};
